<template>
<section class="votervoice-embed">
    <div class="max-w-5xl mx-auto">
        <vv:main v-pre></vv:main>
    </div>
</section>
</template>

<script>
import { onMounted } from 'vue';

export default {

    props: ['data'],
    
    setup(props) {

        onMounted(() => {
            const script = document.createElement('script');
            script.setAttribute('src', props.data.embed_code);
            document.head.appendChild(script);
        });

        return {
            ...props.data
        }
    }

}
</script>